/* Gentle Beauty — announcement bar, sticky header, mega menu, mobile drawer. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  if (window.GBHeader) return;

  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function debounce(fn, wait) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
  function focusables(root) {
    return Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return !el.closest('[inert]') && (el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
  }
  function trapFocus(root) {
    var handler = function (e) {
      if (e.key !== 'Tab') return;
      var f = focusables(root);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', handler, true);
    return function () { document.removeEventListener('keydown', handler, true); };
  }
  function lock() { if (window.GB && window.GB.lock) window.GB.lock(); else document.body.classList.add('gb-lock'); }
  function unlock() { if (window.GB && window.GB.unlock) window.GB.unlock(); else document.body.classList.remove('gb-lock'); }

  window.GBHeader = { trapFocus: trapFocus, focusables: focusables, lock: lock, unlock: unlock, debounce: debounce };

  /* ======================================================================
     Announcement bar
     ====================================================================== */
  if (!customElements.get('gb-announcement')) {
    customElements.define('gb-announcement', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-gb-announce-slide]'));
        this.track = this.querySelector('.gb-announce__track');
        this.index = 0;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.pausedBy = {};

        this.onClick = function (e) {
          if (e.target.closest('[data-gb-announce-prev]')) { self.go(self.index - 1, -1); self.restart(); }
          else if (e.target.closest('[data-gb-announce-next]')) { self.go(self.index + 1, 1); self.restart(); }
          else if (e.target.closest('[data-gb-announce-dismiss]')) { self.dismiss(); }
        };
        this.addEventListener('click', this.onClick);

        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', function () { self.pause('hover'); });
          this.addEventListener('mouseleave', function () { self.resume('hover'); });
        }
        this.addEventListener('focusin', function () { self.pause('focus'); });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.resume('focus'); });
        this.onVisibility = function () { if (document.hidden) self.pause('hidden'); else self.resume('hidden'); };
        document.addEventListener('visibilitychange', this.onVisibility);

        var startX = null;
        this.addEventListener('pointerdown', function (e) { startX = e.clientX; }, { passive: true });
        this.addEventListener('pointerup', function (e) {
          if (startX === null || self.slides.length < 2) return;
          var dx = e.clientX - startX; startX = null;
          if (Math.abs(dx) > 40) { self.go(self.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); self.restart(); }
        }, { passive: true });

        this.onBlockSelect = function (e) {
          var i = self.slides.indexOf(e.target);
          if (i > -1) { self.go(i, 1); self.pause('editor'); }
        };
        this.onBlockDeselect = function (e) { if (self.slides.indexOf(e.target) > -1) self.resume('editor'); };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.initCountdowns();
        this.restart();
      }
      disconnectedCallback() {
        clearInterval(this.timer); clearInterval(this.countTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
      go(i, dir) {
        var n = this.slides.length;
        if (n < 2) return;
        i = (i + n) % n;
        if (i === this.index) return;
        var cur = this.slides[this.index], next = this.slides[i];
        if (this.track) this.track.classList.toggle('is-reverse', dir < 0);
        cur.classList.remove('is-active'); cur.classList.add('is-leaving'); cur.setAttribute('aria-hidden', 'true'); cur.inert = true;
        next.classList.remove('is-leaving'); next.classList.add('is-active'); next.removeAttribute('aria-hidden'); next.inert = false;
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 650);
        this.index = i;
      }
      restart() {
        var self = this;
        clearInterval(this.timer);
        if (!this.autoplay || Object.keys(this.pausedBy).length) return;
        this.timer = setInterval(function () { self.go(self.index + 1, 1); }, this.speed);
      }
      pause(reason) { this.pausedBy[reason] = true; clearInterval(this.timer); }
      resume(reason) { delete this.pausedBy[reason]; this.restart(); }
      dismiss() {
        try { localStorage.setItem(this.dataset.dismissKey, String(Date.now())); } catch (e) {}
        this.hidden = true;
        emit('gb:announce:dismiss', { id: this.id });
      }
      initCountdowns() {
        var timers = Array.prototype.slice.call(this.querySelectorAll('[data-gb-countdown]'));
        if (!timers.length) return;
        var pad = function (n) { return n < 10 ? '0' + n : String(n); };
        timers.forEach(function (el) {
          var raw = (el.getAttribute('data-gb-countdown') || '').trim().replace(' ', 'T');
          if (/T\d{2}:\d{2}$/.test(raw)) raw += ':00';
          if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) raw += 'T23:59:59';
          el._end = new Date(raw).getTime();
        });
        var tick = function () {
          var now = Date.now();
          timers.forEach(function (el) {
            if (isNaN(el._end)) { el.hidden = true; return; }
            var diff = Math.max(0, el._end - now);
            if (diff <= 0) {
              var expired = el.getAttribute('data-expired');
              if (expired) { el.textContent = expired; } else { el.hidden = true; }
              return;
            }
            var s = Math.floor(diff / 1000);
            var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), sec = el.querySelector('[data-s]');
            if (d) d.textContent = pad(Math.floor(s / 86400));
            if (h) h.textContent = pad(Math.floor((s % 86400) / 3600));
            if (m) m.textContent = pad(Math.floor((s % 3600) / 60));
            if (sec) sec.textContent = pad(s % 60);
          });
        };
        tick();
        this.countTimer = setInterval(tick, 1000);
      }
    });
  }

  /* ======================================================================
     Header
     ====================================================================== */
  if (!customElements.get('gb-header')) {
    customElements.define('gb-header', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.section = this.closest('.shopify-section') || this.parentElement;
        this.bar = this.querySelector('[data-gb-header-bar]');
        this.sticky = this.dataset.sticky || 'none';
        this.overlay = this.dataset.overlay === 'true';
        this.overlayMobile = this.dataset.overlayMobile === 'true';
        this.solidHover = this.dataset.solidHover === 'true';
        this.delay = parseInt(this.dataset.hoverDelay, 10) || 0;
        this.clickOnly = this.dataset.trigger === 'click';
        this.lastY = window.scrollY;
        this.offset = null;

        this.measure();

        this.onScroll = function () {
          if (self.ticking) return;
          self.ticking = true;
          window.requestAnimationFrame(function () { self.ticking = false; self.update(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });

        this.onResize = debounce(function () {
          self.measure();
          self.update();
          if (mqDesktop.matches && self.drawer && self.drawer.classList.contains('is-open')) self.closeDrawer();
          if (!mqDesktop.matches && self.openItem) self.closeMenu(self.openItem);
        }, 150);
        window.addEventListener('resize', this.onResize);
        document.addEventListener('gb:announce:dismiss', this.onResize);

        this.initNav();
        this.initDrawer();
        this.initCart();

        if (this.overlay && this.solidHover) {
          this.bar.addEventListener('mouseenter', function () { self.hovering = true; self.updateTransparent(); });
          this.bar.addEventListener('mouseleave', function () { self.hovering = false; self.updateTransparent(); });
        }
        this.addEventListener('focusin', function () { self.focusInside = true; self.updateTransparent(); });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) { self.focusInside = false; self.updateTransparent(); } });

        this.onSearchOpen = function () { if (self.openItem) self.closeMenu(self.openItem); self.classList.add('is-search-open'); self.updateTransparent(); };
        this.onSearchClose = function () { self.classList.remove('is-search-open'); self.updateTransparent(); };
        document.addEventListener('gb:search:open', this.onSearchOpen);
        document.addEventListener('gb:search:close', this.onSearchClose);

        this.onBlockSelect = function (e) {
          if (!self.contains(e.target)) return;
          var item = e.target.closest('[data-gb-nav-item]');
          if (item && item._gb && mqDesktop.matches) { self.openMenu(item); return; }
          if (self.drawer && self.drawer.contains(e.target)) self.openDrawer();
        };
        this.onBlockDeselect = function (e) {
          if (!self.contains(e.target)) return;
          if (self.openItem) self.closeMenu(self.openItem);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', this.onResize);

        this.update();
        this.classList.add('is-ready');
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('gb:announce:dismiss', this.onResize);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('gb:drawer:close', this.onDrawerClose);
        document.removeEventListener('gb:search:open', this.onSearchOpen);
        document.removeEventListener('gb:search:close', this.onSearchClose);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        document.removeEventListener('gb:cart:added', this.onCartAdded);
        if (mqDesktop.removeEventListener) mqDesktop.removeEventListener('change', this.onResize);
        if (this.cartObserver) this.cartObserver.disconnect();
        if (this.releaseTrap) this.releaseTrap();
        if (this.drawer && this.drawer.classList.contains('is-open')) unlock();
      }

      /* ---------- Measurements & scroll state ---------- */
      measure() {
        if (!this.bar) return;
        if (!this.classList.contains('is-scrolled') || this.h === undefined) {
          this.h = this.bar.offsetHeight;
          this.section.style.setProperty('--gb-header-h', this.h + 'px');
          document.documentElement.style.setProperty('--gb-header-height', this.h + 'px');
        }
        var top = 0, el = this.section.previousElementSibling;
        while (el) {
          if (el.classList && el.classList.contains('shopify-section') && !el.hidden) top += el.offsetHeight;
          el = el.previousElementSibling;
        }
        this.startY = top;
      }
      update() {
        var y = window.scrollY;
        var sticky = this.sticky !== 'none';
        var scrolled = sticky && y > this.startY + 4;
        this.classList.toggle('is-scrolled', scrolled);

        if (this.sticky === 'scroll-up') {
          var threshold = this.startY + this.h * 2;
          var busy = this.openItem || this.classList.contains('is-search-open') || (this.drawer && this.drawer.classList.contains('is-open'));
          if (y > this.lastY + 2 && y > threshold && !busy) this.classList.add('is-hidden');
          else if (y < this.lastY - 4 || y <= threshold) this.classList.remove('is-hidden');
        }
        this.lastY = y;

        var offset = sticky && !this.classList.contains('is-hidden') ? this.h : 0;
        if (offset !== this.offset) {
          this.offset = offset;
          document.documentElement.style.setProperty('--gb-header-offset', offset + 'px');
        }
        this.updateTransparent();
      }
      updateTransparent() {
        if (!this.overlay) return;
        var allowed = mqDesktop.matches || this.overlayMobile;
        var solid = this.classList.contains('is-scrolled') || this.classList.contains('is-menu-open') || this.classList.contains('is-search-open') || this.hovering || this.focusInside;
        this.classList.toggle('is-transparent', allowed && !solid);
      }
      setBottom() {
        var b = Math.max(0, Math.round(this.bar.getBoundingClientRect().bottom));
        this.style.setProperty('--gb-header-bottom', b + 'px');
        document.documentElement.style.setProperty('--gb-header-bottom', b + 'px');
      }

      /* ---------- Desktop menus ---------- */
      initNav() {
        var self = this;
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-gb-nav-item]')).filter(function (li) { return li.querySelector('[data-gb-nav-panel]'); });
        this.items.forEach(function (li) {
          var g = li._gb = {
            link: li.querySelector('[data-gb-nav-link]'),
            toggle: li.querySelector('[data-gb-nav-toggle]'),
            panel: li.querySelector('[data-gb-nav-panel]')
          };
          if (!self.clickOnly) {
            li.addEventListener('mouseenter', function () {
              if (!mqHover.matches || !mqDesktop.matches) return;
              clearTimeout(self.closeTimer); clearTimeout(self.openTimer);
              self.openTimer = setTimeout(function () { self.openMenu(li); }, self.openItem ? 40 : self.delay);
            });
            li.addEventListener('mouseleave', function () {
              if (!mqHover.matches || !mqDesktop.matches) return;
              clearTimeout(self.openTimer);
              self.closeTimer = setTimeout(function () { if (self.openItem === li) self.closeMenu(li); }, 240);
            });
          }
          if (g.toggle) {
            g.toggle.addEventListener('click', function (e) {
              e.preventDefault();
              if (self.openItem === li) self.closeMenu(li); else self.openMenu(li, true);
            });
          }
          g.link.addEventListener('click', function (e) {
            var href = g.link.getAttribute('href') || '';
            var hashOnly = href === '' || href === '#' || /#$/.test(href);
            var needsTap = !mqHover.matches || self.clickOnly;
            if (hashOnly || (needsTap && self.openItem !== li)) {
              e.preventDefault();
              if (self.openItem === li) self.closeMenu(li); else self.openMenu(li);
            }
          });
          g.link.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown' || ((e.key === ' ' || e.key === 'Spacebar') && g.link.getAttribute('href') === '#')) {
              e.preventDefault();
              self.openMenu(li);
              window.requestAnimationFrame(function () {
                var f = focusables(g.panel)[0];
                if (f) f.focus();
              });
            }
          });
          li.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && self.openItem === li) {
              e.stopPropagation();
              self.closeMenu(li);
              g.link.focus();
            }
          });
          li.addEventListener('focusout', function (e) {
            if (self.openItem === li && e.relatedTarget && !li.contains(e.relatedTarget)) self.closeMenu(li);
          });
        });

        this.onDocClick = function (e) {
          if (self.openItem && !self.openItem.contains(e.target)) self.closeMenu(self.openItem);
        };
        document.addEventListener('click', this.onDocClick);
      }
      openMenu(li) {
        if (this.openItem === li) return;
        if (this.openItem) this.closeMenu(this.openItem, true);
        var g = li._gb, panel = g.panel;
        if (!panel.hasAttribute('data-mounted')) {
          panel.setAttribute('data-mounted', '');
          void panel.offsetWidth;
        }
        if (panel.classList.contains('gb-dropdown')) {
          panel.classList.remove('is-flipped');
          var r = panel.getBoundingClientRect();
          if (r.right > window.innerWidth - 16) panel.classList.add('is-flipped');
        }
        this.setBottom();
        li.classList.add('is-open');
        panel.classList.add('is-open');
        g.link.setAttribute('aria-expanded', 'true');
        if (g.toggle) g.toggle.setAttribute('aria-expanded', 'true');
        Array.prototype.forEach.call(panel.querySelectorAll('.gb-illustration--draw'), function (el) { el.classList.add('is-visible'); });
        this.openItem = li;
        this.classList.add('is-menu-open');
        this.classList.remove('is-hidden');
        this.updateTransparent();
      }
      closeMenu(li, switching) {
        var g = li._gb;
        if (!g) return;
        li.classList.remove('is-open');
        g.panel.classList.remove('is-open');
        g.link.setAttribute('aria-expanded', 'false');
        if (g.toggle) g.toggle.setAttribute('aria-expanded', 'false');
        if (this.openItem === li) this.openItem = null;
        if (!switching) {
          this.classList.remove('is-menu-open');
          this.updateTransparent();
        }
      }

      /* ---------- Mobile drawer ---------- */
      initDrawer() {
        var self = this;
        this.drawer = document.getElementById(this.dataset.drawer);
        this.burger = this.querySelector('[data-gb-menu-open]');
        if (!this.drawer || !this.burger) return;

        this.burger.addEventListener('click', function (e) { e.preventDefault(); self.openDrawer(); });

        this.drawer.addEventListener('click', function (e) {
          var t = e.target.closest('[data-gb-mm-toggle]');
          if (t) { e.preventDefault(); self.toggleSub(t); return; }
          var cartLink = e.target.closest('[data-gb-mm-cart]');
          if (cartLink) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && document.querySelector('cart-drawer')) {
              e.preventDefault();
              self.closeDrawer();
              setTimeout(function () { bubble.click(); }, 260);
            }
          }
        });

        this.onDrawerClose = function (e) {
          if (!e.detail || e.detail.id !== self.drawer.id) return;
          if (self.releaseTrap) { self.releaseTrap(); self.releaseTrap = null; }
          self.burger.setAttribute('aria-expanded', 'false');
          self.update();
        };
        document.addEventListener('gb:drawer:close', this.onDrawerClose);
      }
      openDrawer() {
        var d = this.drawer;
        if (!d) return;
        if (!d.classList.contains('is-mounted')) {
          d.classList.add('is-mounted');
          void d.offsetWidth;
        }
        if (this.openItem) this.closeMenu(this.openItem);
        this.syncCartCount();
        if (window.GB && window.GB.openDrawer) {
          window.GB.openDrawer(d, this.burger);
        } else {
          d.classList.add('is-open');
          d.setAttribute('aria-hidden', 'false');
          lock();
          var f = focusables(d)[0];
          if (f) f.focus();
        }
        this.burger.setAttribute('aria-expanded', 'true');
        if (this.releaseTrap) this.releaseTrap();
        this.releaseTrap = trapFocus(d);
        Array.prototype.forEach.call(d.querySelectorAll('.gb-illustration--draw'), function (el) { el.classList.add('is-visible'); });
      }
      closeDrawer() {
        var d = this.drawer;
        if (!d || !d.classList.contains('is-open')) return;
        if (window.GB && window.GB.closeDrawer) {
          window.GB.closeDrawer(d);
        } else {
          d.classList.remove('is-open');
          d.setAttribute('aria-hidden', 'true');
          unlock();
          emit('gb:drawer:close', { id: d.id });
        }
      }
      toggleSub(btn) {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (open) {
          var li = btn.closest('li');
          var list = li && li.parentElement;
          if (list) {
            Array.prototype.forEach.call(list.children, function (sib) {
              if (sib === li) return;
              var other = sib.querySelector('[data-gb-mm-toggle][aria-expanded="true"]');
              if (other) this.setSub(other, false);
            }, this);
          }
        }
        this.setSub(btn, open);
      }
      setSub(btn, open) {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!sub) return;
        sub.classList.toggle('is-open', open);
        sub.inert = !open;
        if (open && !mqReduce.matches) {
          var body = this.drawer.querySelector('.gb-mm__body');
          setTimeout(function () {
            if (!body) return;
            var r = btn.getBoundingClientRect(), br = body.getBoundingClientRect();
            if (r.top < br.top || r.top > br.top + br.height * 0.55) body.scrollBy({ top: r.top - br.top - 8, behavior: 'smooth' });
          }, 260);
        }
      }

      /* ---------- Cart count sync + bump ---------- */
      initCart() {
        var self = this;
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        if ('MutationObserver' in window) {
          this.cartObserver = new MutationObserver(function () {
            bubble.classList.remove('is-bumped');
            void bubble.offsetWidth;
            if (!mqReduce.matches) bubble.classList.add('is-bumped');
            self.syncCartCount();
          });
          this.cartObserver.observe(bubble, { childList: true });
        }
        this.onCartAdded = function () { self.syncCartCount(); };
        document.addEventListener('gb:cart:added', this.onCartAdded);
      }
      syncCartCount() {
        var src = document.querySelector('#cart-icon-bubble [data-count]');
        if (!src) return;
        var n = src.getAttribute('data-count') || '0';
        Array.prototype.forEach.call(this.querySelectorAll('[data-gb-mm-cart-count]'), function (el) {
          el.textContent = n;
          el.setAttribute('data-count', n);
        });
      }
    });
  }
})();
